// @flow
import React from 'react';

import { SupportProductKeys } from 'data/products/keys';
import SupportProduct from 'model/SupportProduct';
import t from 'modules/i18n/intl';

const premierSupport = new SupportProduct({
  key: SupportProductKeys.PREMIER_SUPPORT,
  tagLine: t('products.premier-support.tagline'),
  description: t('products.premier-support.description'),
  name: t('products.premier-support.name'),
  longDescription: t(
    {
      id: 'products.premier-support.longDescription',
      defaultMessage:
        'Premier Support connects our top tier engineers with the customer. In order to ensure the best outcomes, we limit the number of individuals within an account to <b>three named contacts</b>.',
    },
    {
      b: (chunks) => <b>{chunks}</b>,
    },
  ),
  moreLink:
    'https://confluence.atlassian.com/support/premier-support-offering-details-593035672.html',
});

export default premierSupport;
